import React from 'react';
import styles from './Shortlist.module.scss';
import { Wave } from 'assets/user/index';

interface BookmarkInfoCardProps {
  title: string;
  description: string;
  buttonText: string;
  mainImg: string;
  alt: string;
}
const BookmarkInfoCard = ({
  title,
  description,
  buttonText,
  mainImg,
  alt,
}: BookmarkInfoCardProps): React.ReactElement => {
  return (
    <div className={`${styles.bookmarkInfoCardContainer} col-xxl-5 col-12`}>
      <img src={mainImg} alt={alt} />
      <div className="d-flex flex-column">
        <h3 className={`${styles.infoCardTitle} mb-0`}>{title}</h3>
        <h6 className={`${styles.infoCardDescription} mb-0`}>{description}</h6>
        <div className="d-flex mt-3 justify-content-between">
          <img src={Wave} alt="wave" className={`${styles.wave} d-none d-sm-block`} />
          <button className={`${styles.button} btn`}>{buttonText}</button>
        </div>
      </div>
    </div>
  );
};

export default BookmarkInfoCard;
